exports.components = {
  "component---src-gatsby-theme-ceteicean-components-ceteicean-tsx": () => import("./../../../src/gatsby-theme-ceteicean/components/Ceteicean.tsx" /* webpackChunkName: "component---src-gatsby-theme-ceteicean-components-ceteicean-tsx" */),
  "component---src-templates-background-tsx": () => import("./../../../src/templates/background.tsx" /* webpackChunkName: "component---src-templates-background-tsx" */),
  "component---src-templates-introduction-tsx": () => import("./../../../src/templates/introduction.tsx" /* webpackChunkName: "component---src-templates-introduction-tsx" */)
}

